export default __webpack_public_path__ + "static/media/pantry2-after2-2048w.afa39215.avif";